// extracted by mini-css-extract-plugin
export var slider = "slider-module--slider--duGqZ";
export var slide = "slider-module--slide--Kdekx";
export var sliderNav = "slider-module--sliderNav--sRh40";
export var navIcon = "slider-module--navIcon--EJG3j";